import React from "react";
import "../styles/whoarewe.scss";
import whoAreWe from "../images/whoarewe.webp";
import Stats from "../components/Stats";

const About = () => {
  return (
    <div className="about-container main-container">
      <div className="about-content">
        <div className="about-text">
          <h1 className="title">Ko smo mi?</h1>
          <p>
            Mi smo vodeći proizvođač uniformi koji se posvećuje pružanju
            visokokvalitetnih proizvoda za medicinske, kuvarske i radne
            industrije. Naša misija je da spojimo stil, udobnost i
            funkcionalnost u svaki naš proizvod, osiguravajući zadovoljstvo
            naših klijenata i dugotrajnost proizvoda.
          </p>
          <p>
            Naša posvećenost inovacijama i održivom razvoju omogućava nam da
            budemo lideri na tržištu uniformi, pružajući našim klijentima
            rešenja koja kombinuju najbolje materijale i najnovije tehnologije.
          </p>
        </div>
        <div className="about-image">
          <img src={whoAreWe} alt="O nama" />
        </div>
      </div>

      <Stats />

      <h2 className="values-title">Naše vrednosti</h2>
      <ul className="values-list">
        <li>
          <strong>Kvalitet:</strong> Posvećeni smo vrhunskom kvalitetu i
          izdržljivosti svakog proizvoda.
        </li>
        <li>
          <strong>Inovacija:</strong> Pratimo najnovije trendove i tehnologije
          kako bismo ostali lideri na tržištu.
        </li>
        <li>
          <strong>Posvećenost:</strong> Naš tim je uvek spreman da pruži
          najbolje za naše klijente, uz visoku profesionalnost.
        </li>
        <li>
          <strong>Održivi razvoj:</strong> Radimo sa ekološki prihvatljivim
          materijalima i trudimo se da smanjimo naš uticaj na životnu sredinu.
        </li>
      </ul>
    </div>
  );
};

export default About;
